<template lang="pug">
  div(class="root")
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.root {
}
</style>
